import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 right-0 w-full md:bottom-8 md:right-12 md:w-auto z-60" }
const _hoisted_2 = { class: "bg-gray-800 text-gray-50 text-sm p-3 md:rounded shadow-lg flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 👉 "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "hover:underline",
    href: "https://github.com/tal7aouy/vue-board",
    target: "_blank",
    rel: "noreferrer"
  }, "Star VueBoard on GitHub")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4 shrink-0 fill-current",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.72 3.293a1 1 0 00-1.415 0L8.012 6.586 4.72 3.293a1 1 0 00-1.414 1.414L6.598 8l-3.293 3.293a1 1 0 101.414 1.414l3.293-3.293 3.293 3.293a1 1 0 001.414-1.414L9.426 8l3.293-3.293a1 1 0 000-1.414z" })
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const open = ref(true);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "text-gray-500 hover:text-gray-400 ml-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
      }, _hoisted_6)
    ])
  ], 512)), [
    [_vShow, open.value]
  ])
}
}

})